const paymentType = {
  TED: 'TED',
  TEV: 'TEV',
  BILLET: 'BILLET'
};

module.exports = paymentType;
